import { EntityBase } from "./EntityBase";
import { Company } from "./Company";

export class BatchExport extends EntityBase {
    batchType: number|null = null;
    seller: Company|null = null;
    dateEntered: Date|null = null;
}
